import { expVal } from '@atlassian/jira-feature-experiments';
import { fg } from '@atlassian/jira-feature-gating';

const JiraTeamButtonTeamCountRelayProvider = {
	get(): boolean {
		return (
			!fg('team-bi-directional-container-connection-gate') &&
			!expVal('team-bi-directional-container-connection', 'isEnabled', false)
		);
	},
};

export default JiraTeamButtonTeamCountRelayProvider;
